export const safeParse = (value, fallback = null) => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const getStoredUser = () => {
  try {
    return safeParse(localStorage.getItem('user'), null);
  } catch {
    return null;
  }
};

export const setStoredUser = (user) => {
  try {
    localStorage.setItem('user', JSON.stringify(user));
  } catch (err) {
    console.error('Unable to save user session', err);
  }
};

export const clearStoredUser = () => {
  try {
    localStorage.removeItem('user');
    localStorage.removeItem('authToken');
  } catch {
    /* ignore */
  }
};
